// Libs
import React from 'react';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import IconContainer from 'components/IconContainer';
import MediumIcon from './MediumIcon';
import NormalIcon from './NormalIcon';

const SelectedIcon = ({ size, fill }) => {
	return {
		// large: <LargeIcon fill={fill} />,
		medium: <MediumIcon fill={fill} />,
		normal: <NormalIcon fill={fill} />,
		// small: <SmallIcon fill={fill} />,
	}[size];
};

const ReportIcon = ({ hoverable, size = 'normal', selected, button }) => {
	const { theme, isDarkTheme } = useTheme();
	const [hover, setHover] = React.useState(false);

	const fill = React.useMemo(
		() =>
			hoverable && (hover || selected)
				? isDarkTheme
					? theme._secondaryColor
					: theme._mediumEmphasisColor
				: theme._mediumEmphasisColor,
		[hover, selected, theme],
	);

	return (
		<div
			style={{ height: '100%' }}
			onMouseEnter={hoverable ? () => setHover(true) : null}
			onMouseLeave={hoverable ? () => setHover(false) : null}
		>
			{button ? (
				<IconContainer>
					<SelectedIcon size={size} fill={fill} />
				</IconContainer>
			) : (
				<SelectedIcon size={size} fill={fill} />
			)}
		</div>
	);
};

export default ReportIcon;
